/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LoginResponseChallengeParametersStruct
 */
export interface LoginResponseChallengeParametersStruct {
    /**
     * 
     * @type {string}
     * @memberof LoginResponseChallengeParametersStruct
     */
    cODEDELIVERYDESTINATION: string;
    /**
     * 
     * @type {string}
     * @memberof LoginResponseChallengeParametersStruct
     */
    cODEDELIVERYMEDIUM: string;
}

/**
 * Check if a given object implements the LoginResponseChallengeParametersStruct interface.
 */
export function instanceOfLoginResponseChallengeParametersStruct(value: object): value is LoginResponseChallengeParametersStruct {
    if (!('cODEDELIVERYDESTINATION' in value) || value['cODEDELIVERYDESTINATION'] === undefined) return false;
    if (!('cODEDELIVERYMEDIUM' in value) || value['cODEDELIVERYMEDIUM'] === undefined) return false;
    return true;
}

export function LoginResponseChallengeParametersStructFromJSON(json: any): LoginResponseChallengeParametersStruct {
    return LoginResponseChallengeParametersStructFromJSONTyped(json, false);
}

export function LoginResponseChallengeParametersStructFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResponseChallengeParametersStruct {
    if (json == null) {
        return json;
    }
    return {
        
        'cODEDELIVERYDESTINATION': json['CODE_DELIVERY_DESTINATION'],
        'cODEDELIVERYMEDIUM': json['CODE_DELIVERY_MEDIUM'],
    };
}

export function LoginResponseChallengeParametersStructToJSON(json: any): LoginResponseChallengeParametersStruct {
    return LoginResponseChallengeParametersStructToJSONTyped(json, false);
}

export function LoginResponseChallengeParametersStructToJSONTyped(value?: LoginResponseChallengeParametersStruct | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'CODE_DELIVERY_DESTINATION': value['cODEDELIVERYDESTINATION'],
        'CODE_DELIVERY_MEDIUM': value['cODEDELIVERYMEDIUM'],
    };
}

